var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('input',{staticClass:"input",class:[_vm.colorClass],attrs:{"type":_vm.type,"id":_vm.id,"data-id":_vm.dataId},domProps:{"value":_vm.value},on:{"input":_vm.onChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }